import { render } from "./vue3-slider.vue?vue&type=template&id=27d511da"
import script from "./vue3-slider.vue?vue&type=script&lang=ts"
export * from "./vue3-slider.vue?vue&type=script&lang=ts"

import "./vue3-slider.vue?vue&type=style&index=0&id=27d511da&lang=scss"
script.render = render

export default script